/**
 * Methods related to the nest dom
 */
import {getScreenHeight} from "./screen";
import _map from "lodash/map";
import _keyBy from "lodash/keyBy";

/**
 * Return all the articles in the DOM
 * @returns {array}
 */
export const getAllArticlesInDom = () => {
    return [...document.getElementsByClassName("article")];
};

/**
 * Return the height of the last article in pixels;
 * @returns {number}
 */
export const getLastArticleHeight = () => {
    const articles = getAllArticlesInDom();
    const lastArticle = articles.length ? articles[articles.length - 1] : null;
    if(lastArticle){
        const {height} = lastArticle.getBoundingClientRect();
        return height;
    } else {
        return 0;
    }
};

/**
 * Return an object that maps groupingId to domnode for all articles
 */
export const getAllDomArticlesMap = () => {
    const screenHeight = getScreenHeight();
    return _map(_keyBy(getAllArticlesInDom(), "dataset.groupingItemId"), (element, key) => {
        const {y, height, top} = element.getBoundingClientRect();
        const fitsInScreen = (screenHeight > height);
        return {
            groupingId: key,
            domElement: element,
            fitsInScreen,
            y,
            height,
            top,
            screenHeight
        }
    });
};
